import type { JSX } from "react";

import { CITY_GUIDE_GOING_OUT_LIMIT, guideCategoryChips } from "@noko-city/shared";

import { Reveal } from "../../Reveal";
import type { SectionRenderInput } from "./types";

import { eventTypeDescription } from "@/lib/city-guide-content";

/**
 * GOING OUT — one tile per named category, with the paragraph that says what that
 * kind of night is. The mix is the backend's ranking whole; this section draws
 * `section.limit` of it and prints nothing else from the list: the chip strip that
 * used to print the tail under the tiles is gone, so the category index a reader
 * sees is the tiles themselves. Names and icons only — the counts that rank this
 * list are never rendered.
 */
export function GoingOutSection({ section, page }: SectionRenderInput): JSX.Element {
  const categories = guideCategoryChips(page.categoryMix).slice(
    0,
    section.limit ?? CITY_GUIDE_GOING_OUT_LIMIT,
  );
  return (
    <ul className="atlas-guide-cards">
      {categories.map((share, position) => (
        <li key={share.slug}>
          <Reveal variant="rise" delay={position * 60}>
            <article className="atlas-guide-tile">
              <p className="atlas-guide-tile-index">{String(position + 1).padStart(2, "0")}</p>
              {share.icon && (
                <span className="atlas-guide-tile-icon" aria-hidden="true">
                  {share.icon}
                </span>
              )}
              <h3 className="atlas-guide-tile-title">{share.name}</h3>
              <p className="atlas-guide-tile-body">{eventTypeDescription(share)}</p>
            </article>
          </Reveal>
        </li>
      ))}
    </ul>
  );
}
